<template>
    <div>
        <section class="itb-references-alike-set" style="margin-top: 3.7rem">
            <div class="container">
                <div class="row">
                    <div
                        class="col-12 col-md-4"
                        v-for="playground in playgrounds"
                    >
                        <router-link
                            class="text-decoration-none"
                            :to="{
                                name: 'playgroundDetail',
                                params: {
                                    playgroundAlias: playground.alias
                                        ? playground.id + '-' + playground.alias
                                        : ''
                                }
                            }"
                        >
                            <div
                                class="card w-100 itb-with-border itb-margin-bottom itb-lazy-loading-bg"
                                v-lazy:background-image="
                                    playground.imageHero
                                        ? '/uploads/' +
                                          playground.imageHero.path +
                                          '/sm_' +
                                          playground.imageHero.name
                                        : null
                                "
                            >
                                <div class="card-body d-flex p-0">
                                    <div class="itb-text align-self-end w-100">
                                        <h3 class="mb-0">
                                            {{
                                                playground.title
                                                    ? playground.title
                                                    : ""
                                            }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>

        <BenefitsBar />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BenefitsBar from "../components/BenefitsBar";

export default {
    data() {
        return {
            pageParams: [],
            playgrounds: []
        };
    },

    components: {
        BenefitsBar
    },

    mounted() {
        axios
            .get("/getPlaygroundsPage")
            .then(response => {
                this.pageParams = response.data.params;
                this.playgrounds = response.data.playgrounds;
                this.pageParams.achievementClass = "itb-smaller";
                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams"
        })
    },

    methods: {
        ...mapActions(["setPageParams"])
    }
};
</script>
